export default "__VITE_ASSET__c737c703__"